import React, {Component} from 'react';
import '../../../styles/Home.css'
import Footer from "../../../shared/Footer";
import AplikacjaMobilna from "./../AplikacjaMobilna";
import Newsletter from "./../Newsletter";
import OnasTekst from "./OnasTekst";

export default class Regulaminy extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showReg: this.props.showReg
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return <div>
            <div className="wynajemNaglowek przerywnik">
                <div className="container text-center">
                    <h2><b>Największy przewoźnik w regionie. </b></h2>
                    <h4>Jesteśmy największą firmą przewozową w regionie posiadającą tabor ponad 100 autobusów.</h4>
                </div>
            </div>
            <div className="panelPaddingMobilka"
                 style={{background: '#f9f9f9', paddingTop: '15px', paddingBottom: '15px'}}>
                <div className="container" style={{background: '#fff', padding: 0}}>
                    <div className="aktualnosci ramka wynik">
                        <div className="row" style={{width: '100%'}}>
                            <div className="col-sm-12 text-center" style={{paddingTop: 75}}>
                                <h2 style={{fontWeight: 'bold'}}>O nas</h2>
                                <hr/>
                                <div>
                                    <OnasTekst/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*<AplikacjaMobilna/>*/}
            <Newsletter/>
            <Footer/>
        </div>
    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/firmaComponents/FirmaOnas.js